import { DataProvider, GlobalActionsProvider } from '@plasmicapp/host';
import { useABTestStore } from 'hooks/stores/useABTestStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { observer } from 'mobx-react-lite';
import React from 'react';


export const UIGlobalContext = observer(
  ({ children }: React.PropsWithChildren) => {
    const { abTests } = useABTestStore();

    const {
      enterFlowProgress,
      showVideoOverlay,
      setShowVideoOverlay,
      setVideoOverlayLink,
      setVideoOverlayType,
      removeVideoOverlayLink,
    } = useUIStore();


    return (
      <GlobalActionsProvider
        contextName="UIGlobalContext"
        actions={{
          setShowVideoOverlay,
          setVideoOverlayLink,
          removeVideoOverlayLink,
          setVideoOverlayType,
        }}
      >
        <DataProvider
          name="ui"
          data={{
            enterFlowProgress,
            showVideoOverlay,
            abTests,
          }}
        >
          {children}
        </DataProvider>
      </GlobalActionsProvider>
    );
  }
);
